<template>
    <div class="co-lista-modelos" v-if="modelos.length">
        <v-flex class="px-3 mt-5">
            <v-flex class="modelos-lista-header d-flex align-center px-2">
                <v-col cols="11" class="dados">
                    <v-col cols="4" class="mr-3">
                        <div class="dados">Título</div>
                    </v-col>
                    <v-col cols="3" class="mr-3">
                        <div class="dados">Data/Hora</div>
                    </v-col>
                    <v-col cols="3" class="mr-3">
                        <div class="dados">Situação</div>
                    </v-col>
                </v-col>

                <v-col cols="1">
                    <div class="dados justify-end">Ações</div>
                </v-col>
            </v-flex>
        </v-flex>

        <v-flex v-for="modelo in modelos" :key="modelo.id" class="px-3 mt-3 w-100">
            <v-flex class="modelos-lista d-flex align-center">
                <div class="modelos px-2 d-flex align-center">
                    <v-col cols="11" class="dados" @click="visualizar(modelo.id)">
                        <v-col cols="4" class="dados ml-2 mr-3">
                            <v-icon color="secondary-200" size="20"> mdi-file-document </v-icon>
                            <div class="ellipsis ml-2">
                                {{ modelo.titulo }}
                            </div>
                        </v-col>

                        <v-col cols="3" class="dados mr-3">
                            <div class="ellipsis">
                                {{ modelo.dataHora }}
                            </div>
                        </v-col>

                        <v-col cols="3" class="dados mr-3">
                            <div class="ellipsis">
                                {{ modelo.situacao }}
                            </div>
                        </v-col>
                    </v-col>
                </div>

                <div class="acoes ml-2">
                    <v-icon v-if="!ehMobile" size="20" color="secondary-200" @click="editarModelo(modelo.id)">
                        mdi-file-document-edit
                    </v-icon>
                    <v-menu open-on-hover top left offset-y>
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on" size="20" color="secondary-200"> mdi-dots-vertical </v-icon>
                        </template>
                        <v-list>
                            <v-list-item @click="abrirDialogRenomear(modelo)">
                                <v-list-item-title>
                                    <v-icon class="mr-2" size="18px">mdi-pencil</v-icon>
                                    Renomear
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="duplicarModelo(modelo.id)">
                                <v-list-item-title>
                                    <v-icon class="mr-2" size="18px">mdi-content-copy</v-icon>
                                    Duplicar
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="abrirDialogConfirmardeletarModelo(modelo.id)">
                                <v-list-item-title>
                                    <v-icon class="mr-2" size="18px">mdi-delete</v-icon>
                                    Excluir
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </v-flex>
        </v-flex>

        <v-row no-gutters class="justify-space-between mt-3 mx-3">
            <v-flex class="footer">
                <v-pagination
                    dense
                    class="paginas justify-center elevation-0"
                    v-model="paginacao.page"
                    :length="paginacao.numPages"
                    :total-visible="7"
                    @input="mudarPagina"
                />

                <v-spacer v-if="!ehMobile" />

                <v-select
                    v-if="!ehMobile"
                    class="linhas-por-pagina"
                    v-model="paginacao.rowsPerPage"
                    :items="quantidadesLinhas"
                    label="Itens por pagina"
                    hide-details
                    @change="mudarQuantidadePorPagina"
                />
            </v-flex>
        </v-row>
    </div>

    <lista-modelos-vazia v-else />
</template>

<script>
import ListaModelosVazia from './components/ListaModelosVazia'

export default {
    name: 'ListaModelos',
    components: {
        ListaModelosVazia,
    },
    props: {
        modelos: {
            type: Array,
            required: true,
        },
        paginacao: {
            type: Object,
            required: true,
        },
        quantidadesLinhas: {
            type: Array,
            required: true,
        },
    },
    computed: {
        ehMobile() {
            return this.$vuetify.breakpoint.xsOnly
        },
    },
    methods: {
        abrirDialogRenomear(modelo) {
            this.$emit('abrir-dialog-renomear', modelo)
        },
        abrirDialogConfirmardeletarModelo(modeloId) {
            this.$emit('abrir-confirmar-deletar', modeloId)
        },
        duplicarModelo(modeloId) {
            this.$emit('duplicar', modeloId)
        },
        editarModelo(modeloId) {
            this.$emit('editar', modeloId)
        },
        mudarPagina() {
            this.$emit('mudar-pagina')
        },
        mudarQuantidadePorPagina() {
            this.$emit('mudar-quantidade-por-pagina')
        },
        visualizar(modeloId) {
            this.$emit('visualizar', modeloId)
        },
    },
}
</script>

<style lang="stylus">
.co-lista-modelos
    .modelos-lista-header
        border 1px solid var(--background-300)
        background-color var(--background-200)
        border-radius 5px
        height 46px
        position relative

        .dados
            display flex
            height 45px
            width 100%
            position relative
            align-items center
            text-align left
            color var(--text-color-300)

    .modelos-lista
        border 1px solid var(--background-300)
        border-radius 5px
        cursor pointer
        height 46px
        position relative

        .modelos
            width 100%

        .dados
            display flex
            height 45px
            width 100%
            position relative
            align-items center
            text-align left
            color var(--text-color-300)
            margin 0
            padding 0

            .ellipsis
                display block
                align-items center
                text-overflow ellipsis
                white-space nowrap
                overflow hidden
                width 100%

            .pasta-nome
                font-size 10px

        .acoes
            position absolute
            margin-top 5px
            right 5px
            display flex

    .footer
        display flex
        position relative
        align-content space-between

        .paginas
            width 100%
            align-content center

        .linhas-por-pagina
            position absolute
            right 0
            width 100px
</style>
